import { createStore } from "vuex"
import { app } from "./app.js"
//import appStore from "./app_store.js";
import { auth } from "./auth.js"
import { activities } from "./activities.js"
import { app_downloads } from "./app_downloads.js"
import { cdr } from "./cdr.js"
import { chats } from "./chats.js"
import { clients } from "./clients.js"
import { complaints } from "./complaints.js"
import { complaints_list } from "./complaints_list.js"
import { customers } from "./customers.js"
import { feeds } from "./feeds.js"
import { meters } from "./meters.js"
import { offices } from "./offices.js"
import { payment_history } from "./payment_history.js"
import { region_districts } from "./region_districts.js"
import { user_permissions } from "./user_permissions.js"
import { user_roles } from "./user_roles.js"
import { users } from "./users.js"

//const { state, getters, mutations, actions } = appStore;

const store = createStore({
	modules: {
		app,
		auth,
		activities,
		app_downloads,
		cdr,
		chats,
		clients,
		complaints,
		complaints_list,
		customers,
		feeds,
		meters,
		offices,
		payment_history,
		region_districts,
		user_permissions,
		user_roles,
		users
	},
	// enable strict mode (adds overhead!)
	// for dev mode only
	//strict: process.env.DEV
});
export default store;